export enum ProofIncomeStatesEnumeration {
  LANDING = 'LANDING', // Choose method
  METHOD = 'METHOD', // Iframe
}
